<template>
  <el-dialog title="开始标注" :visible.sync="visible" width="450px" :before-close="() => (visible = false)">
    <el-radio-group v-model="action" class="auto-tag-picker">
      <el-radio label="autoTag1" class="radio-li">
        <div class="radio-li-title">叠加规则运行</div>
        <div class="radio-li-tip">指在原来规则的基础上，加上新增规则来清洗未标注的案件。</div>
      </el-radio>
      <el-radio label="autoTag2" class="radio-li">
        <div class="radio-li-title">覆盖规则运行</div>
        <div class="radio-li-tip">指以当前全新的规则重新清洗全部案件。</div>
      </el-radio>
    </el-radio-group>
    <span slot="footer">
      <el-button class="footer-btn" @click="visible = false">再想想</el-button>
      <el-button class="footer-btn" type="primary" @click="confirmHandle">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      action: ''
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'autoTag1'
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  created() {
    this.action = this.type;
  },
  methods: {
    confirmHandle() {
      if (!this.action) {
        this.$message.warning('请选择标注规则');
        return;
      }
      this.$emit('success', this.action);
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-btn {
  width: 100px;
}
.auto-tag-picker {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 10px;

  .radio-li {
    width: 100%;
    display: flex;
    margin-top: 20px;

    &:first-child {
      margin-top: 10px;
    }
    .radio-li-title {
      color: #2c3443;
      font-size: 14px;
    }
    .radio-li-tip {
      color: #77839e;
      font-size: 12px;
      line-height: 17px;
      margin-top: 4px;
    }
  }
}
</style>
